import React from 'react';
import mascotDefault from '../../../../assets/svg/onboarding/mascot-default.svg';
import mascotBio from '../../../../assets/svg/onboarding/mascot-bio-fill.svg';
import mascotCollaborationOne from '../../../../assets/svg/onboarding/mascot-collaborate-1-fill.svg';
import mascotCollaborationTwo from '../../../../assets/svg/onboarding/mascot-collaborate-2-fill.svg';
import mascotHappy from '../../../../assets/svg/onboarding/mascot-happy.svg';
import mascotDeault from '../../../../assets/svg/onboarding/mascot-bio.svg';
/**
 * MascotCharacter Component
 *
 * Displays the mascot character that moves based on progress
 *
 * @param {Number} currentStep - Current step index
 * @param {Number} totalSteps - Total number of steps
 */
const MascotCharacter = ({ currentStep, totalSteps }) => {
  // Calculate position based on current step
  const progressPercentage = (currentStep / (totalSteps - 1)) * 100;

  /**
   * Returns the appropriate SVG based on the current step
   */
  const getMascotSvg = () => {
    switch (currentStep) {
      case 0:
        return <img src={mascotDefault} />;
      case 1:
        return <div style={{ height: '90px' }}></div>;
      case 3:
        return <img src={mascotBio} />;
      case 4:
        return (
          <>
            <img src={mascotCollaborationOne} style={{ marginRight: '10px' }} />
            <img src={mascotCollaborationTwo} />
          </>
        );
      case 6:
        return <div style={{ height: '90px' }}></div>;

      case 7:
        return <img src={mascotHappy} style={{ height: '70px' }} />;

      default:
        return <img src={mascotDeault} />;
    }
  };

  return (
    <div
      className="mascot-container"
      style={{
        left: `${progressPercentage}%`,
        transform: 'translateX(-50%)',
        transition: 'left 0.5s ease-in-out'
      }}
    >
      {getMascotSvg()}
    </div>
  );
};

export default MascotCharacter;
